







































































































import {Vue, Component, Prop} from "vue-property-decorator";
import axiosInstance from "../../../../axios";
// @ts-ignore
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/material_blue.css';
import { Russian } from "flatpickr/dist/l10n/ru.js";
import * as dayjs from 'dayjs'
import {Notification} from "../../../../../types/notifications";
import Activity = Notification.Activity;
import {Statistic} from "../../../../../types/statistic";
import {Tool} from "../../../../helpers/Tool";

@Component({
    components: {flatPickr},
})

export default class Detailed extends Vue {
    @Prop({required: true}) private tagName!: string|undefined;
    @Prop({required: true}) private codeName!: string|undefined;

    private dataDetailed: Statistic.Invites|null = null;
    private date: string = '';
    private config: any = {
        locale: Russian,
        dateFormat: 'Y.m.d',
        mode: 'range',
        defaultDate: this.date,
    };
    //@ts-ignore
    private dateFrom: string = dayjs().subtract(30, 'days').format('YYYYMMDD');
    //@ts-ignore
    private dateTo: string = dayjs().format('YYYYMMDD');

    private activeTags: Array<string> = [];
    private ascSorting: boolean = true;

    mounted(): void {
        this.getCurrentData();
    }

    /**
     * Сумма по всем тэгам
     * @private
     */
    private get totalData(): Statistic.Invite|null
    {
        if (this.dataDetailed) {
            return this.dataDetailed['total'].total;
        }

        return null;
    }

    /**
     * Получить данные по тегу или по коду
     * @private
     */
    private getCurrentData(): void
    {
        if (this.codeName) {
            this.getTotalCodeInfo();
            return;
        }

        this.getTotalTagInfo();
    }

    /**
     * Детальная инфа по тегу
     * @private
     */
    private getTotalTagInfo(): Promise<{[key: number]: Activity}>
    {
        const params = new URLSearchParams();
        if (this.dateFrom) {
            params.append('date_from', this.dateFrom);
        }
        if (this.dateTo) {
            params.append('date_to', this.dateTo);
        }

        return new Promise((resolve, reject) => {
            axiosInstance.get(`/statistics/invites/tags/${this.tagName}`)
                .then(response => {
                    if (typeof response.data.errors === 'undefined') {
                        this.dataDetailed = response.data.response.data;
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                }).catch(error => {
                reject(error);
            });
        });
    }

    /**
     * Детальная инфа по коду
     * @private
     */
    private getTotalCodeInfo(): Promise<{[key: number]: Activity}>
    {
        const params = new URLSearchParams();
        if (this.dateFrom) {
            params.append('date_from', this.dateFrom);
        }
        if (this.dateTo) {
            params.append('date_to', this.dateTo);
        }

        return new Promise((resolve, reject) => {
            axiosInstance.get(`/statistics/invites/codes/${this.codeName}`)
                .then(response => {
                    if (typeof response.data.errors === 'undefined') {
                        this.dataDetailed = response.data.response.data;
                        resolve(response.data);
                    } else {
                        reject(response.data);
                    }
                }).catch(error => {
                reject(error);
            });
        });
    }

    /**
     * Получить минуты из секунд
     * @param sec
     * @private
     */
    private getMinutes(sec: number): number
    {
        return Tool.getMinutesFromSeconds(sec);
    }

    /**
     * Изменить дату в календаре
     * @param selectedDates
     * @private
     */
    private changeDate(selectedDates: any): void
    {
        // @ts-ignore
        this.dateFrom = typeof selectedDates[0] !== 'undefined' ? dayjs(selectedDates[0]).format('YYYYMMDD') : '';
        // @ts-ignore
        this.dateTo = typeof selectedDates[1] !== 'undefined' ? dayjs(selectedDates[1]).format('YYYYMMDD') : '';

        this.getCurrentData();
    }

    /**
     * Очистить дату в календаре
     * @private
     */
    private clearDate(): void
    {
        this.dateFrom = '';
        this.dateTo = '';
        this.date = '';

        this.getCurrentData();
    }

    /**
     * Показать/скрыть таблицу
     * @param name
     * @private
     */
    private toggleTable(name: string): void
    {
        if (this.activeTags.includes(name)) {
            this.activeTags = this.activeTags.filter(tag => tag !== name);
        } else {
            this.activeTags.push(name);
        }
    }

    /**
     * Сортировать по алфавиту
     * @private
     */
    private sortByName(): void
    {
        if (this.ascSorting) {
            if (this.dataDetailed) {
                this.dataDetailed = Object.keys(this.dataDetailed).sort().reduce(
                    (obj, key) => {
                        // @ts-ignore
                        obj[key] = this.dataDetailed[key];
                        return obj;
                    },
                    {}
                );
            }
        }
        else {
            if (this.dataDetailed) {
                this.dataDetailed = Object.keys(this.dataDetailed).sort().reverse().reduce(
                    (obj, key) => {
                        // @ts-ignore
                        obj[key] = this.dataDetailed[key];
                        return obj;
                    },
                    {}
                );
            }
        }

        this.ascSorting = !this.ascSorting;
    }

    /**
     * Вернуться назад к списку тэгов/инвайтов
     * @private
     */
    private backToTagsList(): void
    {
        this.$emit('back-to-tags-list');
    }
}
